module.exports = __webpack_public_path__ + "static/img/nut_002.a4c32b71.png";